import { Base } from '@studiometa/js-toolkit';

/**
 * PickupAvailability Radios
 */
export default class PickupAvailability extends Base {
  /**
   * Component Configuration
   */
  static config = {
    name: 'PickupAvailability',
  };

  /**
   * [mounted description]
   * @returns {void}
   */
  mounted() {
    if (!this.$el.hasAttribute('available')) return;

    this.errorHtml = this.$el.querySelector('template').content.firstElementChild.cloneNode(true);
    this.onClickRefreshList = this.$el.onClickRefreshList.bind(this);
    // this.fetchAvailability(this.$el.dataset.variantId);
  }

  /**
   * [fetchAvailability description]
   * @param  {[type]} variantId [description]
   * @returns {void}           [description]
   */
  fetchAvailability(variantId) {
    let { rootUrl } = this.$el.dataset;

    if (!rootUrl.endsWith('/')) {
      rootUrl += '/';
    }
    const variantSectionUrl = `${rootUrl}variants/${variantId}/?section_id=pickup-availability`;

    fetch(variantSectionUrl)
      .then((response) => response.text())
      .then((text) => {
        const sectionInnerHTML = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('.shopify-section');
        this.renderPreview(sectionInnerHTML);
      })
      .catch(() => {
        // const button = this.$el.querySelector('button');
        // if (button) button.removeEventListener('click', this.$el.onClickRefreshList);
        this.renderError();
      });
  }

  /**
   * [onClickRefreshList description]
   * @returns {void}
   */
  // onClickRefreshList() {
  //   this.fetchAvailability(this.$el.dataset.variantId);
  // }

  /**
   * [renderError description]
   * @returns {void}
   */
  renderError() {
    this.innerHTML = '';
    if (this.errorHtml !== undefined) {
      this.$el.append(this.errorHtml);
      // this.$el.querySelector('button').addEventListener('click', this.$el.onClickRefreshList);
    }
  }

  /**
   * [renderPreview description]
   * @param  {object} sectionInnerHTML
   * @returns {void}
   */
  renderPreview(sectionInnerHTML) {
    const drawer = document.querySelector('pickup-availability-drawer');
    if (drawer) drawer.remove();
    if (!sectionInnerHTML.querySelector('pickup-availability-preview')) {
      this.$el.innerHTML = '';
      this.$el.removeAttribute('available');
      return;
    }

    this.$el.innerHTML = sectionInnerHTML.querySelector('pickup-availability-preview').outerHTML;
    this.$el.setAttribute('available', '');

    document.body.append(sectionInnerHTML.querySelector('pickup-availability-drawer'));
    const colorClassesToApply = this.$el.dataset.productPageColorScheme.split(' ');
    colorClassesToApply.forEach((colorClass) => {
      document.querySelector('pickup-availability-drawer').classList.add(colorClass);
    });

    const button = this.querySelector('button');
    if (button)
      button.addEventListener('click', (evt) => {
        document.querySelector('pickup-availability-drawer').show(evt.target);
      });
  }
}
